<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class=" section" v-on:click="goTo('/apms')">Taquillas</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Información</a>
    </div>
    <h1 v-if="apmName" class="ui header"><img class="ui image" src="../../assets/apm.png">
      <div class="content">{{ apmName.name }}</div>
    </h1>
    <button class="ui basic button rightButton" v-on:click="goTo('/apms')">
      <i class="long arrow alternate left icon"></i>Atras
    </button>

    <div v-if="!selectedApm" class="ui active centered inline loader"></div>
    <div v-if="selectedApm" class="ui stackable sixteen column divided grid container">
      <div class="row">
        <div class="six wide column">
          <h4 class="ui dividing header">Información de la taquilla</h4>
          <div class="form ui">
            <div class="field">
              <label>Horario</label>
              <input type="text" v-model="apmName.open" readonly>
            </div>
            <div class="field">
              <label>Donde se encuentra?</label>
              <input type="text" v-model="apmName.findme" readonly>
            </div>
            <div class="field">
              <label>Dirección</label>
              <input type="text" v-model="selectedApm.address" readonly>
            </div>
            <div class="field">
              <label>Código Postal</label>
              <input type="text" v-model="selectedApm.postal_code" readonly>
            </div>
            <div class="field">
              <label>Ciudad</label>
              <input type="text" v-model="selectedApm.group" readonly>
            </div>
            <div class="field">
              <label>Provincia</label>
              <input type="text" v-model="selectedApm.subgroup" readonly>
            </div>
            <div class="field">
              <label>Contacto de tienda</label>
              <textarea type="text" rows="5" v-model="selectedApm.observations"> </textarea>
            </div>
          </div>
        </div>
        <div v-if="rows.length > 0" class="ten wide column">
          <h4 class="ui dividing header">Columnas</h4>
          <div class="form ui">
            <div class="field">

              <table class="ui selectable table">
                <thead>
                  <tr>
                    <th class="azpian">Tipo Columna</th>
                    <th class="azpian">ID</th>
                    <th class="azpian">ID Fabricante</th>
                    <th class="azpian">Fecha Recepción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="val in rows" :key="val.id" :id="'idLine_' + val.id" @click="viewProductDetail(val, true)"
                    class="clickable-row">
                    <td :id="'idStockName_' + val.id"> {{ val.name }} </td>
                    <td :id="'idID_' + val.id"> {{ val.product_identifier }} </td>
                    <td :id="'idIDProv_' + val.id"> {{ val.product_identifier_prov }} </td>
                    <td :id="'idReceive_date_' + val.id"> {{ val.receive_date }} </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- <div>
          <div class="google-map" ref="googleMap"></div>
          <template v-if="Boolean(this.google) && Boolean(this.map)">
            <slot :google="google" :map="map" />
          </template>
</div> -->
        </div>
        <h4 v-if="historyRows.length > 0" class="ui dividing header">Historial de actuaciones</h4>
        <div v-if="historyRows.length > 0" class="ui stackable grid container">
          <div class="row">
            <div class="column">
              <form class="ui form">
                <table class="ui selectable table">
                  <thead>
                    <tr>
                      <th class="azpian">Fecha Actuación</th>
                      <th class="azpian">APM</th>
                      <th class="azpian">Actuación</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="val in historyRows" :key="val.id" :id="'idLine_' + val.id"
                      @click="viewProductDetail(val, false)" class="clickable-row">
                      <td :id="'idActionDate_' + val.id"> {{ val.action_date.split(" ")[0] }} </td>
                      <td :id="'idAptName_' + val.id"> {{ val.apm_name }} </td>
                      <td :id="'idTypeName_' + val.id"> {{ val.type }} </td>
                    </tr>
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import GoogleMapsApiLoader from 'google-maps-api-loader'
import { hapiickApi } from '@/api/hapiickApi';

export default {
  name: 'Info',
  props: ['id'],
  data() {
    return {
      totalActions: 0,
      searching: false,
      search: {
        apt_id: [],
      },
      selectedApm: null,
      apmName: null,
      map: null,
      google: null,
      rows: [],
      historyRows: []
    }
  },
  created() {
    this.getApmInfo();
    this.searchAction();
    this.apmInfo();
  },
  methods: {
    async getApmInfo() {
      await hapiickApi().post('/v1/apms/get-apm', {
        admin_id: JSON.parse(localStorage.admin).id,
        apm_id: this.id
      })
        .then(request => {
          this.selectedApm = JSON.parse(JSON.stringify(request.data.data.apm))
          this.apmName = JSON.parse(JSON.stringify(request.data.data.name))
        })
        .catch(() => console.log('error getting apm'))
    },
    async apmInfo() {
      await hapiickApi().post('/v1/apts/columns', {
        admin_id: JSON.parse(localStorage.admin).id,
        apt_id: this.id
      })
        .then(request => {
          let columns = JSON.parse(JSON.stringify(request.data.columns));
          this.rows = columns;
        })
        .catch(() => console.log("error getting apm columns"))
    },
    async searchAction() {
      this.searching = true
      this.rows = []

      let search = {}
      search['apm'] = [this.id];
      await hapiickApi().post('/v1/actions/search', {
        admin_id: JSON.parse(localStorage.admin).id,
        search: search
      })
        .then(request => {
          this.historyRows = JSON.parse(JSON.stringify(request.data.data.actions));
          this.searching = false
        })
        .catch((err) => {
          this.searching = false
          this.$swal({
            type: 'error',
            title: 'Error',
            text: 'Error al obtener las actuaciones.'
          })

          this.rows.push({
            'action_date': 'no encontrado',
          })
        })
    },
    viewProductDetail(val, isColumn) {
      let routeData = this.$router.resolve(((isColumn) ? '/inventory/stock/detail/' : '/inventory/action/info/') + val.id);
      window.open(routeData.href, '_blank');
    },
    goTo(where) {
      this.$router.push(where)
    },
    initializeMap() {
      let latlng = new google.maps.LatLng(39.305, -76.617);
      let mapConfig = {
        center: latlng,
        zoom: 12
      }
      const mapContainer = this.$refs.googleMap
      this.map = new this.google.maps.Map(mapContainer, mapConfig)
    }
  }
}
</script>
<style scoped>
.clickable-row {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Apms/Info.vue